import React from 'react';
export const pointDraggableItemContent = (item) => {
    return (
        <span>
            Id: <b>{(item?.id || '').toString().toUpperCase() }</b>
            <br />
            Orden: <b>{item.showOrder}</b>  &nbsp;&nbsp;&nbsp;    Original: <b>{item.originalOrder}</b>
            <br />
            LatLng: <b>{(item?.position?.lat )+ ', ' + ( item?.position?.lng || 0 ) + ', ' + ( item.position?.alt || 0.0 )}</b>
        </span>
    );
};